import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { Pros } from "src/providers/pros/pros";
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { CustomNavController } from "src/shared/providers/navigation/custom-nav-controller";
import validationUtils from "src/shared/util/validation-utils";
import { Util } from 'src/shared/util/util';
import { MyProPage } from 'src/pages/my-pros/my-pro/my-pro';
import { parsePhoneNumber } from 'src/tidy-ui-components/components/form/input-international-phone/international-number.utils';

@Component({
    templateUrl: 'edit-pro.html',
    standalone: false
})
export class MyProsEditProPage implements OnInit {

  private pro: Partial<{
    id: string;
    name: string;
    email: string;
    phone: string;
  }>;
  private proId: number;
  public form: FormGroup;
  public submitted: boolean;
  public errorMessage: string;
  loaded: boolean;
  isRightSideContent: boolean;
  dialogParams: any;
  countryCode: string;
  proCountryCode: string;


  boundUpdate = this.update.bind(this);

constructor(
    private navCtrl: CustomNavController,
    private route: ActivatedRoute,
    private pros: Pros,
    private fb: FormBuilder,
    private rightSidePanelService: RightSidePanelService,
    private storage: TidyStorage,
    private util: Util
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, validationUtils.validateEmail]],
      phone: ''
    });
  }

  async ngOnInit() {
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    if (this.isRightSideContent) {
      this.dialogParams = await this.storage.retrieve('dialog-params');
      this.rightSidePanelService.setDialogPageTitle('Edit Pro');
    }
    this.pro = this.navCtrl.getParam('pro') || this.dialogParams?.pro;
    this.proId = +parseInt(this.route.snapshot.paramMap.get('proId')) || this.dialogParams?.proId;
    if (!this.pro) {
      try {
        await this.retrieveProDetail();
      } catch (_err) {
        this.navCtrl.back();
      }
    }
    this.fillForm();
    this.loaded = true;
  }

  async retrieveProDetail() {
    const proDetail = await this.pros.getProDetail(this.proId);
    this.pro = proDetail.homekeeper;
  }

  fillForm() {
    this.form.patchValue(this.pro);
  }

  onCountryCodeChange(countryCode: string) {
    this.countryCode = countryCode.replace('+', '');
  }

  async update() {
    this.submitted = true;
    if (this.form.invalid) {return;}
    try {
      const proInfo = {
        ...this.form.value,
        phone: parsePhoneNumber(this.countryCode + this.form.value.phone)
      };
      await this.pros.updateProInfo(this.proId, proInfo);
      this.util.showSuccess('Payment Sent');
      const params = {
        proId: this.proId
      }
      this.rightSidePanelService.navigateTo(`my-pro/${this.proId}`, params, MyProPage);
    } catch (err) {
      this.errorMessage = err?.error?.message ?? err?.message;
    }
  }

}
